module.exports = __webpack_public_path__ + "img/prescription-bottle-medical.ac6fb46b.svg";